import React, { useEffect } from 'react';
import './style.scss';
import { IconColor, IconSize, SvgIcon } from 'views/components/atoms/svgIcon';
import { ProductCard } from 'views/components/molecules/product';
import { formatThousand } from 'views/utils/calc/formatThousand';
import { operationDatePlanCalc } from 'views/utils/calc/operationDatePlan';
import { GetApplicationInfoQueryVariables, GetSymbolInfoQueryVariables } from 'views/utils/graphql/graphql';
import { IconName, findIcon } from 'views/utils/handleIcon';
import { useGetSymbolDetail } from '../productDetail/hooks/useGetSymbolDetail';
import { CreateOrderDetailProps, createOrderDetail } from './function/createOrderDetail';
import { Button, ButtonSize, FillType } from 'views/components/atoms/button';
import { useGlobalLoadingHandler } from 'views/components/organisms/globalLoading/hook';

type OrderDetailProps = {
  symbol: string;
  data: CreateOrderDetailProps | undefined;
  setCloseModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const OrderDetail = (props: OrderDetailProps) => {
  const param: GetSymbolInfoQueryVariables = {
    symbol: props.symbol,
  };
  const { symbolDetail, setSymbolDetailVariables, getSymbolDetail } = useGetSymbolDetail(param);

  const { showLoading, hideLoading, setLoadingCenter } = useGlobalLoadingHandler();

  const getNewOrderDetailVariables = () => {
    const param: GetApplicationInfoQueryVariables = {
      id: props.symbol || '',
    };
    return param;
  };

  useEffect(() => {
    setLoadingCenter(true);
    if (symbolDetail.fetching) {
      showLoading();
    } else {
      hideLoading();
    }
  });

  const data = symbolDetail.data?.GetSymbolInfo;

  const icon = findIcon(IconName.PdfFile);
  return (
    <div>
      {props.data && createOrderDetail(props.data)}
      <ProductCard
        title={data?.SymbolName || ''}
        image={data?.ImageUrl || ''}
        description={data?.Overview || ''}
        TradeStartDate={data?.TradeStartDate || ''}
        TradeEndDate={data?.TradeEndDate || ''}
        details={[
          {
            title: '一口',
            item: formatThousand(data?.PricePerUnit || 0) || '',
            frontUnit: '',
            rearUnit: '万円',
          },
          {
            title: '予想分配率',
            item: data?.ExpectedInterestRate.toString() || '',
            frontUnit: '年',
            rearUnit: '%',
          },
          {
            title: '予定運用期間',
            item: operationDatePlanCalc(data?.OperationStartDate || '', data?.OperationEndDate || ''),
            frontUnit: '約',
            rearUnit: '',
          },
        ]}
        tradable={data?.Tradable || false}
      />

      <div className="linkPDF">
        <div className="linkPDF_anchor">
          <SvgIcon icon={icon} size={IconSize.icon_m} color={IconColor.gray} />
          <a href={data?.ProspectusUrl || ''} target="_blank" rel="noreferrer noopener">
            目論見書
          </a>
        </div>
        <div className="linkPDF_anchor">
          <SvgIcon icon={icon} size={IconSize.icon_m} color={IconColor.gray} />
          <a href={data?.PreContractDocumentUrl || ''} target="_blank" rel="noreferrer noopener">
            契約締結前交付書面
          </a>
        </div>
      </div>

      <Button
        label="閉じる"
        fillType={FillType.primaryFill}
        buttonSize={ButtonSize.sizeM}
        onClick={() => {
          props.setCloseModal(false);
        }}
      />
    </div>
  );
};
